import React from "react";

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="border-b border-black/10 bg-white px-8 py-6 flex items-end justify-between gap-6 flex-wrap">
    <div>
      <div className="overline mb-2">{subtitle}</div>
      <h1 className="font-display text-3xl font-bold text-navy tracking-tight">{title}</h1>
    </div>
    {action}
  </div>
);

export const Stat = ({ label, value, hint }) => (
  <div className="bg-white border border-black/10 p-5">
    <div className="overline">{label}</div>
    <div className="ship-number mt-2 text-3xl font-black text-navy leading-none">{value}</div>
    {hint && <div className="mt-2 text-xs text-navy/50">{hint}</div>}
  </div>
);

export const Badge = ({ children, tone = "neutral" }) => {
  const tones = {
    neutral: "bg-navy/5 text-navy/70 border-navy/10",
    green: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    red: "bg-red-50 text-red-700 border-red-200",
    ember: "bg-ember/10 text-ember-600 border-ember/30",
    navy: "bg-navy text-white border-navy",
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[10px] uppercase tracking-widest border ${tones[tone] || tones.neutral}`}>
      {children}
    </span>
  );
};

export const AgentJsonBox = ({ data, testId = "agent-json-box" }) => (
  <pre data-testid={testId} className="bg-navy text-white/90 text-xs p-4 overflow-x-auto border border-black/20 font-mono whitespace-pre-wrap break-words max-h-[420px]">
    {JSON.stringify(data, null, 2)}
  </pre>
);

export const Empty = ({ label }) => (
  <div className="bg-white border border-dashed border-black/15 p-10 text-center text-sm text-navy/50">{label}</div>
);

export const categoryTone = (cat) => {
  if (cat === "interested") return "green";
  if (cat === "request_more_info") return "ember";
  if (cat === "not_now") return "amber";
  if (cat === "not_interested" || cat === "unsubscribe") return "red";
  return "neutral";
};

export const statusTone = (s) => {
  if (["qualified", "approved", "active", "sent"].includes(s)) return "green";
  if (["pending", "nurture", "draft"].includes(s)) return "amber";
  if (["rejected", "archived"].includes(s)) return "red";
  if (s === "contacted") return "ember";
  return "neutral";
};
